module.exports = __webpack_public_path__ + "img/Tessellate28.497f9d8a.jpg";